import { Button } from '../../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { PlatformConfig } from './types';

type PlatformCardProps = {
  config: PlatformConfig;
  url: string;
};

export const PlatformCard = ({ config, url }: PlatformCardProps): JSX.Element => {
  return (
    <Card className="group h-full rounded-2xl border border-gray-200 shadow-sm transition-all duration-300 ease-out cursor-pointer overflow-hidden hover:-translate-y-1 hover:shadow-xl hover:border-gray-300">
      <CardHeader className="pb-3">
        <div className="flex justify-center mb-4 p-[clamp(16px,4vw,24px)] bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl group-hover:from-blue-50 group-hover:to-slate-100 transition-colors duration-300">
          <img src={config.icon} alt={config.name} className="object-contain drop-shadow-md" />
        </div>
        <CardTitle className="text-center text-[clamp(16px,4vw,20px)] font-semibold text-gray-800 min-h-[3rem] flex items-center justify-center leading-tight">
          {config.name}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <Button
          asChild
          size="lg"
          className="w-full h-12 sm:h-11 text-base sm:text-[15px] font-medium rounded-full shadow-sm hover:scale-105 hover:shadow-lg hover:bg-primary transition-all duration-200"
        >
          <a href={url} target="_blank" rel="noopener noreferrer">
            Go to Platform
          </a>
        </Button>
      </CardContent>
    </Card>
  );
};
